import { useI18n } from 'vue-i18n';

import type { MessageSchema } from '@/shared/utils/i18n';

export const useTranslations = () => {
  return useI18n<{ message: MessageSchema }>({
    useScope: 'global'
  });
};
